document.addEventListener('alpine:init', () => {
  Alpine.data('testimonials', () => ({
    swiper: null,

    init() {
      if (!window.wp) {
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    },

    initSwiper() {
      new Swiper(this.$refs.swiperContainer, {
        speed: 400,
        slidesPerView: 1,
        navigation: {
          prevEl: this.$refs.prevButton,
          nextEl: this.$refs.nextButton,
        },
        pagination: {
          el: this.$refs.pagination,
          type: 'bullets',
          clickable: true,
        },
      });

      setTimeout(() => this.$refs.navigation.removeAttribute('data-cloak'));
    },
  }));
});